import React from 'react';
import { Link } from 'react-router-dom';

export const AccessDeniedPage = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>403 - Brak uprawnień</h1>
      <p>Nie masz dostępu do tej strony.</p>
      <Link to="/">Wróć na stronę główną</Link>
    </div>
  );
};